import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, Grid, LL_H_C, LL_V_L, SimpleListAdapter, TS_DropDown, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ICONS, QuaiManager_DropDownCaret } from '@app/styles';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { countryOptions } from '../../../consts.js';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DropDown_OrgCountry, ModuleFE_Organization } from '../../../../../_entity/organization/index.js';
import './Editor_Organization_GeneralInformation.scss';
import { DefaultEditor_InputNumeric_Optional, DefaultEditor_InputText, DefaultEditor_InputText_Array, DefaultEditor_InputText_Optional } from '@app/styles/frontend/ui-manager/ui-components';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
const viewKey = 'view';
const editKey = 'edit';
export class Editor_Organization_GeneralInformation extends TS_EditableItemComponentProto {
    // ######################## Lifecycle ########################
    permissionKey_OrganizationEdit = ModuleFE_Organization.permissions.collection.edit;
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        return state;
    }
    // ######################## Logic ########################
    getCountryOption = (country) => {
        const option = countryOptions.find(option => option.country === country);
        if (!option)
            throw new MUSTNeverHappenException('Chose a country option not from the list???');
        return option;
    };
    updateAddress = async (key, value) => {
        const org = this.state.editable;
        const address = org.item.address ? { ...org.item.address } : {};
        address[key] = value;
        if (key === 'country') {
            const option = this.getCountryOption(value);
            address['stateRequired'] = !!option.states?.length;
            if (!address['stateRequired'])
                delete address['state'];
        }
        await this.updateOrg('address', address);
    };
    updateOrg = async (key, value) => {
        const org = this.state.editable;
        try {
            await org.updateObj({ [key]: value });
        }
        catch (err) {
            this.logError(err);
        }
        finally {
            this.forceUpdate();
        }
    };
    getModeKey = () => {
        return this.state.editMode ? editKey : viewKey;
    };
    // ######################## Render ########################
    render() {
        const className = _className(this.state.editMode && 'edit-mode');
        const addressEditable = this.state.editable.editProp('address', {});
        return _jsxs(LL_V_L, { id: 'editor-organization-general-information', className: className, children: [_jsx("div", { className: 'editor-organization__info-title', children: "General Information" }), _jsxs(Grid, { children: [this.renderName(), this.renderAlias(), this.renderAddress(addressEditable), this.renderCity(addressEditable), this.renderState(addressEditable), this.renderZipcode(addressEditable), this.renderCountry(addressEditable), this.renderWebsite(), this.renderWebDomains()] })] });
    }
    renderName = () => {
        const org = this.state.editable;
        return _jsx(_Fragment, { children: _jsx(TS_PropRenderer.Flat, { label: 'Name', error: org.hasError('name'), children: _jsx(Component_SwitchView, { mode: this.getModeKey(), modes: [
                        { key: viewKey, renderer: () => _jsx("div", { className: 'grid-data', children: org.item.name }) },
                        {
                            key: editKey,
                            permissionKey: this.permissionKey_OrganizationEdit,
                            renderer: () => _jsx(DefaultEditor_InputText, { editable: org, prop: 'name', onChange: value => this.updateOrg('name', value) })
                        },
                    ] }) }) });
    };
    renderAlias = () => {
        const org = this.state.editable;
        return _jsx(TS_PropRenderer.Flat, { label: 'Alias', error: org.hasError('alias'), children: _jsx(Component_SwitchView, { mode: this.getModeKey(), modes: [
                    { key: viewKey, renderer: () => _jsx("div", { className: 'grid-data', children: org.item.alias ?? '-' }) },
                    {
                        key: editKey, permissionKey: this.permissionKey_OrganizationEdit,
                        renderer: () => _jsx(DefaultEditor_InputText_Optional, { editable: org, prop: 'alias', onChange: value => this.updateOrg('alias', value ?? '') })
                    }
                ] }) });
    };
    renderAddress = (addressEditable) => {
        return _jsx(TS_PropRenderer.Flat, { label: 'Address', error: addressEditable.hasError('address'), children: _jsx(Component_SwitchView, { mode: this.getModeKey(), modes: [
                    {
                        key: viewKey,
                        renderer: () => _jsx("div", { className: 'grid-data', children: addressEditable.item.address ?? '-' })
                    },
                    {
                        key: editKey, permissionKey: this.permissionKey_OrganizationEdit,
                        renderer: () => _jsx(DefaultEditor_InputText_Optional, { editable: addressEditable, prop: 'address', onChange: value => this.updateAddress('address', value) })
                    }
                ] }) });
    };
    renderCity = (addressEditable) => {
        return _jsx(TS_PropRenderer.Flat, { label: 'City', error: addressEditable.hasError('city'), children: _jsx(Component_SwitchView, { mode: this.getModeKey(), modes: [
                    {
                        key: viewKey,
                        renderer: () => _jsx("div", { className: 'grid-data', children: addressEditable.item.city ?? '-' })
                    },
                    {
                        key: editKey, permissionKey: this.permissionKey_OrganizationEdit,
                        renderer: () => _jsx(DefaultEditor_InputText, { editable: addressEditable, prop: 'city', onChange: value => this.updateAddress('city', value) })
                    }
                ] }) });
    };
    renderZipcode = (addressEditable) => {
        return _jsx(TS_PropRenderer.Flat, { label: 'Zip', error: addressEditable.hasError('zipCode'), children: _jsx(Component_SwitchView, { mode: this.getModeKey(), modes: [
                    {
                        key: viewKey,
                        renderer: () => _jsx("div", { className: 'grid-data', children: addressEditable.item.zipCode ?? '-' })
                    },
                    {
                        key: editKey, permissionKey: this.permissionKey_OrganizationEdit,
                        renderer: () => _jsx(DefaultEditor_InputNumeric_Optional, { editable: addressEditable, prop: 'zipCode', type: 'number', onChange: value => this.updateAddress('zipCode', Number(value)) })
                    }
                ] }) });
    };
    renderWebsite = () => {
        const org = this.state.editable;
        return _jsx(TS_PropRenderer.Flat, { label: 'Website', error: org.hasError('webUrl'), children: _jsx(Component_SwitchView, { mode: this.getModeKey(), modes: [
                    { key: viewKey, renderer: () => _jsx("div", { className: 'grid-data', children: org.item.webUrl ?? '-' }) },
                    {
                        key: editKey, permissionKey: this.permissionKey_OrganizationEdit,
                        renderer: () => _jsx(DefaultEditor_InputText, { editable: org, prop: 'webUrl', onChange: value => this.updateOrg('webUrl', value) })
                    }
                ] }) });
    };
    renderWebDomains = () => {
        const org = this.state.editable;
        const editable = org.editProp('webDomains', []);
        return _jsx(TS_PropRenderer.Flat, { label: 'Web Domains', error: org.hasError('webUrl'), children: _jsx(Component_SwitchView, { mode: this.getModeKey(), modes: [
                    {
                        key: viewKey,
                        renderer: () => _jsx(LL_V_L, { children: editable.item.map(webDomain => _jsx("div", { className: 'grid-data', children: webDomain }, webDomain)) })
                    },
                    {
                        key: editKey, permissionKey: this.permissionKey_OrganizationEdit,
                        renderer: () => {
                            return _jsxs(LL_V_L, { children: [editable.item.map((domain, i) => _jsxs(LL_H_C, { children: [_jsx(DefaultEditor_InputText_Array, { editable: editable, prop: i, onChange: value => editable.updateArrayAt(value.toLowerCase(), i) }), _jsx(ICONS.x.component, { onClick: async () => {
                                                    await editable.removeArrayItem(i);
                                                } })] })), _jsx(Button, { variant: 'primary', onClick: () => editable.updateArrayAt(''), children: "Add Web Domain" })] });
                        }
                    }
                ] }) });
    };
    renderCountry = (addressEditable) => {
        return _jsx(TS_PropRenderer.Flat, { label: 'Country', error: addressEditable.hasError('country'), children: _jsx(Component_SwitchView, { mode: this.getModeKey(), modes: [
                    {
                        key: viewKey,
                        renderer: () => _jsx("div", { className: 'grid-data', children: addressEditable.item.country ?? '-' })
                    },
                    {
                        key: editKey, permissionKey: this.permissionKey_OrganizationEdit,
                        renderer: () => _jsx(DropDown_OrgCountry.editable, { editable: addressEditable, prop: 'country', onSelected: async (countryOption) => await this.updateAddress('country', countryOption) })
                    }
                ] }) });
    };
    renderState = (addressEditable) => {
        if (!addressEditable.item.stateRequired || !addressEditable.item.country)
            return;
        const countryOption = this.getCountryOption(addressEditable.item.country);
        const adapter = SimpleListAdapter(countryOption.states, op => _jsx(_Fragment, { children: op.item.initials ?? op.item.label }));
        return _jsx(TS_PropRenderer.Flat, { label: 'State', error: addressEditable.hasError('state'), children: _jsx(Component_SwitchView, { mode: this.getModeKey(), modes: [
                    {
                        key: viewKey,
                        renderer: () => _jsx("div", { className: 'grid-data', children: addressEditable.item.state?.initials ?? addressEditable.item.state?.label ?? '-' })
                    },
                    {
                        key: editKey, permissionKey: this.permissionKey_OrganizationEdit,
                        renderer: () => _jsx(TS_DropDown, { caret: QuaiManager_DropDownCaret, adapter: adapter, selected: addressEditable.item.state, onSelected: async (state) => await this.updateAddress('state', state) })
                    }
                ] }) });
    };
}
//# sourceMappingURL=Editor_Organization_GeneralInformation.js.map